var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.95204 6.25L8.9519 9.71154L20 9.71154V10.2885L8.9519 10.2885L8.95204 13.75L0 10L8.95204 6.25Z","fill":"#455464"}));
}

ArrowLeft.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
